import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { ColDef, GridOptions } from 'ag-grid-community';
import { TableData, TableRow } from '../report-table/report-table.component';
import { EllipsisCellComponent } from '../ellipsis-cell/ellipsis-cell.component';

type Row = Record<string, any>;
type Header = Record<string, any>;
@Component({
  selector: 'report-table-v2',
  templateUrl: './report-table-v2.component.html',
  standalone: true,
  imports: [CommonModule, AgGridModule], // <- REQUIRED
  styleUrls: ['./report-table-v2.component.scss']
})
export class ReportTableV2Component implements OnInit, OnChanges {

  constructor() {

  }


  defaultColDef: ColDef = {
    resizable: true,
    sortable: true,
    width: 70,
  };

  processUnpinnedColumns(p: any) {
    // console.log("processUnpinnedColumns", p);
    return [];
  }
  getRowId = (p: any) =>
    `${p.data.facilityId}:${p.data.firstName}:${p.data.lastName}:${p.data.startDate ?? p.data.admissionDate}`;


  @Input() gridOptions: GridOptions;
  @Input() tableData: TableData;
  @Input() pinnedLeftNumOfColumns: number;
  rows: Row[];
  columns: ColDef[];

  ngOnInit(): void {
    this.updateTableData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tableData'] && !changes['tableData'].firstChange) {
      this.updateTableData();
    }
  }

  private updateTableData(): void {
    if (!this.tableData) {
      return;
    }

    this.rows = this.tableData.rows;
    // alert(JSON.stringify(Object.keys(this.tableData.headers)))
    this.columns = getOrderedHeaders(this.tableData.headers).map((header, index) => ({
      field: header,
      headerName: this.tableData.headers[header as keyof typeof this.tableData.headers]['label'] || '',
      valueGetter: (p: any) => {
        // console.log("valueGetter", p);
        // check if data string
        if (typeof p.data[header as keyof typeof p.data] === 'string') {
          return p.data[header as keyof typeof p.data];
        }
        // console.log(p.data[header as keyof typeof p.data]);
        return p.data[header as keyof typeof p.data]?.value || '';
      },
      cellStyle: (p: any) => {
        const colSettings: TableRow = p.data[header as keyof typeof p.data];
        if (colSettings) {
          const obj: any = {};
          if (colSettings.bgColor) {
            obj.backgroundColor = colSettings.bgColor;
          }
          if (colSettings.color) {
            obj.color = colSettings.color;
          }
          if (colSettings.textAlign) {
            obj.textAlign = colSettings.textAlign;
          }
          return obj;
        }
        return undefined;
      },
      //   cellRenderer: (p: any) => {
      //     // console.log("cellRenderer", p);      // check if data string
      //     if (typeof p.data[header as keyof typeof p.data] === 'string') {
      //       return p.data[header as keyof typeof p.data];
      //     }
      //     // console.log(p.data[header as keyof typeof p.data]);
      //     return p.data[header as keyof typeof p.data]?.value || '';

      //   },
      cellRenderer: EllipsisCellComponent,
      pinned: this.pinnedLeftNumOfColumns && index < this.pinnedLeftNumOfColumns ? 'left' : null,
      minWidth: undefined,
      flex: this.tableData.headers[header as keyof typeof this.tableData.headers]['width'] || 1
    }));
    console.log(this.columns);
  }

}
function getOrderedHeaders(headers: Record<string, { label: string, index?: number }>) {
  const entries = Object.keys(headers);

  // 1) keys עם index
  const withIndex = entries.filter(k => headers[k].index !== undefined);

  // 2) keys בלי index
  const withoutIndex = entries.filter(k => headers[k].index === undefined);

  // 3) בניית מערך מיקומים
  const result = [];

  // שים לפי index (0-based)
  withIndex.forEach(k => {
    result[headers[k].index] = k;
  });

  // 4) מלא את החורים לפי סדר הכנסת שאר המפתחות
  withoutIndex.forEach(k => {
    let i = 0;
    while (result[i] !== undefined) i++;
    result[i] = k;
  });
  console.log(result);
  return result;

}